const chatBotStyles = {
  cardEmphasisBackgroundColor: "#E9E9E9",
  hideSendBox: false,
  hideUploadButton: true,

  bubbleBackground: "transparent",
  bubbleBorderColor: "transparent",
  bubbleBorderRadius: 8,
  bubbleBorderStyle: "solid",
  bubbleBorderWidth: 1,
  bubbleNubOffset: "bottom" as const,  // ✅ corregido
  bubbleNubSize: 10,
  bubbleMaxWidth: 100,                 // ✅ corregido
  bubbleMinHeight: 30,
  bubbleMinWidth: 250,
  bubblePadding: 10,                   // ✅ corregido y bien escrito
  bubbleTextColor: "Black",

  bubbleFromUserBackground: "#EBF6FF",
  bubbleFromUserBorderColor: "#EBF6FF",
  bubbleFromUserBorderRadius: 8,
  bubbleFromUserBorderStyle: "solid",
  bubbleFromUserBorderWidth: 1,
  bubbleFromUserNubOffset: "bottom" as const, // ✅ corregido
  bubbleFromUserNubSize: 10,
  bubbleFromUserTextColor: "black",

  bubbleImageMinHeight: 240, // ✅ sin px
  bubbleImageMaxHeight: 240, // ✅ sin px

  sendBoxBackground: "white",
  sendBoxButtonColor: "#0074D4",
  sendBoxButtonColorOnFocus: "#0067CC",
  sendBoxButtonColorOnHover: "#0067CC",
  sendBoxTextColor: "#666666",

  sendBoxBorderBottom: "solid 2px #0074D4",
  sendBoxBorderLeft: "solid 2px #0074D4",
  sendBoxBorderRight: "solid 2px #0074D4",
  sendBoxBorderTop: "solid 2px #0074D4",

  groupTimestamp: false,
  timestampColor: "#767676",
  timestampFormat: "relative" as const,
};

export default chatBotStyles;
